// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202608040604/js/" + chunkId + "." + {"44":"49ac802f","225":"81989beb","481":"10d94d96","486":"1f8125e8","770":"97c2d599"}[chunkId] + ".0.8295799743071574.chunk.js";
};